import { Navigation, Autoplay, Keyboard, Lazy } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/keyboard";
import "swiper/css/autoplay";
import "swiper/css/lazy";
import loading from '../assets/images/imageLoading.gif'
import Slide1 from "../assets/images/item-1.jpg";
import Slide2 from "../assets/images/item-2.jpg";
import Slide3 from "../assets/images/item-3.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
const Slider = () => {
  return (
    <Box className="section-with-carousel" >
    <Swiper
      modules={[Navigation, Keyboard, Autoplay, Lazy]}
      keyboard
      slidesPerView={1}
      loop={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      navigation={true}
      Lazy={true}
    >
      <SwiperSlide >
        <div >
          <LazyLoadImage
            className="swiper-lazy"
            src={Slide1}
            alt={"slide1"}
            placeholderSrc={loading}
            style={{ width: "100%",height:'100%',objectFit:'cover',objectPosition:'center' }}
          />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div>
          <LazyLoadImage
            className="swiper-lazy"
            src={Slide2}
            alt={"slide2"}
            style={{ width: "100%" }}
          />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div>
          <LazyLoadImage
            className="swiper-lazy"
            src={Slide3}
            alt={"slide3"}
            style={{ width: "100%" }}
          />
        </div>
      </SwiperSlide>
    </Swiper>
    </Box>
  );
};

export default Slider;
